export default {
	about_the: 'Sobre as',
	about_the: 'Sobre a',
	document: 'CPF',
	company_agency: 'Loja registrada no seu perfil:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explore todo o nosso universo de cursos, vídeos, artigos e arquivos.',
	project_name: 'Educa Tigre',
	welcome_to: 'Bem-vindo(a) à',
	point: 'Ponto Educa | Pontos Educa',
	points: 'Pontos Educa',
	point_plural: 'Pontos Educa',
	challenge_of_the_day: 'Desafio dos Feras \\ Desafio Extras',
	profession: 'Qual sua área de atuação hoje?',
}
